import { doc, getDoc, getFirestore } from 'firebase/firestore/lite';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { createMapAtom } from '../common/mapAtom';
import { setMultiple, setSingle } from '../common/common';
import { jotaiStore } from '../store';
import db from '@creator/sdk/modules/db';
import creatorSdk from '@src/services/creator-sdk';

export interface PostStats {
    id: string;
    totalViews: number;
}

const postStatsAtom = createMapAtom<PostStats>({
    initialValue: {},
    debugLabel: 'postStatsAtom',
});

export const postStatsAtomFamily = atomFamily((postId: string | undefined) => {
    const derivedAtom = atom<PostStats | undefined>(get => (postId ? get(postStatsAtom)[postId] : undefined));
    derivedAtom.debugLabel = `postStatsAtomFamily/${postId}`;
    return derivedAtom;
});

export function getPostStatsAtom() {
    return postStatsAtom;
}

export function getPostStats() {
    return jotaiStore.get(postStatsAtom);
}

export function setPostStats(postStats: PostStats) {
    setSingle(postStats, postStatsAtom);
}

export function setMultiplePostStats(postStats: Record<string, PostStats>) {
    setMultiple(postStats, postStatsAtom);
}

export const loadPostStatsAtom = atom(null, async (get, set, postId: string) => {
    const db = getFirestore(creatorSdk.getApp());

    const statsDoc = await getDoc(doc(db, 'Post', postId, 'stats', 'metrics'));
    const statsData = statsDoc.data();
    if (!statsData) return {};
    const postStats: PostStats = {
        id: postId,
        totalViews: statsData.totalViews || 0,
    };

    setPostStats(postStats);
    return postStats;
});
loadPostStatsAtom.debugLabel = 'loadPostStatsAtom';
